import { Component, input } from '@angular/core';
import { AppDetails } from '../../classes/application-details';

@Component({
    selector: 'app-application-summary',
    templateUrl: './application-summary.component.html',
    styleUrls: ['./application-summary.component.scss']
})
export class ApplicationSummaryComponent {
    details = input.required<AppDetails>();
}
